const bugReportPrefix = /^Bug Report:\s*/i;

export const getIssueDisplayTitle = (title: string, description?: string) => {
  let displayTitle = title;

  if (bugReportPrefix.test(title) && title.endsWith('...') && description) {
    const reportText = description.match(
      /\*\*Description:\*\*\s*\n([\s\S]*?)(?=\n\n\*\*(?:Device Information|Reporter Email|Reporter|User ID|Attachments|Logs):?\*\*|$)/
    )?.[1]?.trim();

    if (reportText) displayTitle = reportText;
  }

  return displayTitle.replace(bugReportPrefix, '').trim();
};
